import { useState } from 'react';

export const useSearch = (list: unknown[], attribute?: string[]) => {
  const [query, setQuery] = useState<string>();
  const data = (list || []).filter((item: Record<string, string>) => {
    const modified = attribute ? attribute.map((attr: string) => item[attr]) : item;
    const value = JSON.stringify(modified);
    return value?.match(RegExp(query, 'gi'))?.length > 0;
  });
  const onSearch = (q: string) => {
    setQuery(q);
  };

  return { data, onSearch };
};
